<template>
<nav id="site-navigation" class="has-branding main-navigation nav-align-right sub-menu-right" aria-label="Primary" itemtype="https://schema.org/SiteNavigationElement" itemscope>
  <div class="inside-navigation">
    <div class="navigation-branding">
      <div class="site-logo">
        <a href="/" title="GBWhatsApp" rel="home">
          <img class="header-image is-logo-image" alt="GBWhatsApp" src="../assets/logo-new.png" title="GBWhatsApp">
        </a>
      </div>
      <p class="main-title" itemprop="headline">
        <a href="/" rel="home">
          GB WhatsApp
        </a>
      </p>
    </div>
    <ul id="menu-primary-menu" class="menu sf-menu mobile-menu-page" v-show="isMenuClicked">
      <li id="menu-item-32" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-32">
        <a href="/">Home</a>
      </li>
      <li id="menu-item-33" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="/download/" class="download-btn">Download</a>
      </li>
    </ul>

    <div id="primary-menu" class="main-nav">
      <!-- mobile -->
      <div class="mobile-menu" v-if="$global.isMobileDevice()">
        <div class="menu-toggle" @click="isMenuClicked=!isMenuClicked">
          <img src="@/assets/menu.svg" alt="menu button" v-if="!isMenuClicked">
          <img src="@/assets/xmark-black.svg" alt="close button" v-else>
        </div>
      </div>
      <!-- pc -->
      <ul v-else id="menu-primary-menu" class="menu sf-menu">
        <li id="menu-item-32" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-32">
          <a href="/">Home</a>
        </li>
        <li id="menu-item-33" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33 header-download">
          <a href="/download/" class="download-btn">Download</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
</template>

<script>
import Search from './Search.vue';
export default {
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
    gotodownload: {
      type: Function,
    },
    apk: {
      type: Object,
    },
  },
  components: {
    Search,
  },
  data() {
    return {
      isHovered: false,
      isMenuClicked: false,
      isModClicked: false,
      isSearchClicked: false,
      lang: [{
          lang: 'en',
          val: '🇺🇸 English'
        },
        {
          lang: 'ar',
          val: '🇦🇪 اَلْعَرَبِيَّةُ'
        },
        {
          lang: 'id',
          val: '🇮🇩 Bahasa Indonesia'
        },
        {
          lang: 'pt',
          val: '🇵🇹 Português'
        },
        {
          lang: 'es',
          val: '🇪🇸 Español'
        },
        {
          lang: 'hi',
          val: '🇮🇳 हिंदी'
        },
      ],
      translation: {
        en: {
          home: 'Home',
          download: 'Download',
          blogs: 'Blogs',
          mod: 'WhatsApp Mods',
        },
        ar: {
          home: 'الصفحة الرئيسية',
          download: 'تحميل',
          blogs: 'المدونات',
          mod: 'مودات واتس اب',
        },
        id: {
          home: 'Beranda',
          download: 'Unduh',
          blogs: 'Blog',
          mod: 'Mod WhatsApp',
        },
        pt: {
          home: 'Casa',
          download: 'Baixar',
          blogs: 'Blogs',
          mod: 'Mods do WhatsApp',
        },
        es: {
          home: 'Casa',
          download: 'Descargar',
          blogs: 'Blogs',
          mod: 'Mods de WhatsApp',
        },
        hi: {
          home: 'घर',
          download: 'डाउनलोड',
          blogs: 'ब्लॉग',
          mod: 'व्हाट्सएप मोड्स',
        },
      },
    }
  },
  watch: {
    isSearchClicked(newVal) {
      if (!newVal) {
        this.$refs.searchComponent?.resetSearch();
      }
    }
  },
  methods: {
    changeLanguage(lang) {
      console.log("changelang: ", lang);
      console.log("page: ", this.page);
      this.$router.push({
        name: `${this.selectedLanguage}-${this.page}`
      });
    },
    download() {
      if (typeof this.gotodownload === "function") {
        this.gotodownload();
      } else {
        console.error("gotodownload is not a function");
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#site-navigation {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

  .inside-navigation {
    width: 100%;
    max-width: 1120px;
    margin: 0 auto;
    padding-left: 32px;
    padding-right: 32px;
    box-sizing: border-box;
    z-index: 9999;
    position: relative;
  }
}

#backtop {
  width: 30px;
  height: 30px;
  position: fixed;
  right: 50px;
  bottom: 100px;
  background: #f0f0f0;
  padding: 10px;
  border-radius: 50%;
  box-sizing: content-box;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.main-nav {
  .menu {
    list-style-type: none !important;
    margin: 0 !important;
    li {
      a {
        font-weight: 500 !important;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .inside-navigation {
    padding-left: 20px;
    padding-right: 20px;

    .mobile-menu-page {
      position: absolute;
      top: 100%;
      width: 100%;
      z-index: 1001;
      margin: 0 !important;

      .menu-item {
        padding: 14px 0;
        margin-bottom: 0 !important;
        background: #fff;

        a, div {
          font-size: 15px;
          text-align: center;
          color: #121212;
          display: block;
        }
      }
    }
  }

  .main-nav {
    flex: 1;
    margin-right: 10px;

    .mobile-menu {
      display: flex;
      justify-content: flex-end;
      position: relative;

      .language-selector {
        width: 60%;

        #language-select {
          width: 100%;
        }
      }

      .menu-toggle {
        display: block;
        display: flex;
        justify-content: center;
        padding: 12px 12px;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }

      .search-toggle {
        display: block;
        padding: 12px 12px;
        display: flex;
        justify-content: center;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }
    }
  }
}
</style>
